import React from 'react'

import independent from '../../img/independent.png'
import empower from '../../img/empower.png'
import grow from '../../img/grow.png'

export default function WhyJoinUs() {
    return (
        <div className='text-center px-10 my-10'>
            <h1 className='md:text-6xl text-4xl my-10 '>
                Why <span className='text-orange-700'>Join</span> Us?
            </h1>
            <p className='md:text-3xl text-xl md:px-20 my-5'>
                Our core beliefs serve as a solid framework for our goal and obligation
                to transform the counseling landscape in India.
            </p>
            <div className='grid md:grid-cols-3 place-items-center my-10'>
                <Why 
                    image={independent}
                    desc='Be Independent'
                />
                <Why 
                    image={empower}
                    desc='Empower Yourself'
                />
                <Why 
                    image={grow}
                    desc='Grow with us'
                />
            </div>
        </div>
    )
}

function Why(props){
    return (
        <div className="card bg-base-100 m-3 w-80 ">
                <img src={props.image} alt="Why Join Us" className="rounded-xl" />
            <div className="card-body items-center text-center">
                <p className='md:text-2xl text-xl font-semibold'>{props.desc}</p>
            </div>
        </div>
    )
    
    }